import { FC } from 'react';
import { IconButtonProps, IconButton, styled } from '@mui/material';

interface ExpandIconButtonProps extends IconButtonProps {
    expand: boolean;
}

const StyledExpandIconButton = styled(({ expand, ...props }: ExpandIconButtonProps) => {
    return <IconButton {...props} />;
})(({ theme, expand }) => ({
    '& .MuiSvgIcon-root': {
        transform: expand ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
}));

const ExpandIconButton: FC<ExpandIconButtonProps> = (props) => {
    return <StyledExpandIconButton {...props} />;
};

export type { ExpandIconButtonProps };
export default ExpandIconButton;
